import React from 'react';
import CustomTextField, { CustomTextFieldProps } from './customTextField';

export default function EmailTextField({
  label,
  id = 'email',
  name = 'email',
  typographyVariantSize = 'f16',
  labelTypographyVariantSize = 'f12',
  wrapperSxProps,
  ...props
}: CustomTextFieldProps) {
  return (
    <CustomTextField
      label={label}
      id={id}
      name={name}
      typographyVariantSize={typographyVariantSize}
      labelTypographyVariantSize={labelTypographyVariantSize}
      placeholder={props.placeholder}
      wrapperSxProps={{
        width: 1,
        ...wrapperSxProps,
      }}
      {...props}
    ></CustomTextField>
  );
}
